import {
  PayrollConceptFragment,
  PayrollConceptsDocument,
  PayrollValueObjectsConceptCategoryEnum,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useConcepts = (
  policyPeriodId?: number,
  categories?: PayrollValueObjectsConceptCategoryEnum[],
  withActiveStatus?: boolean,
  skip = false
) => {
  const { loading, data, refetch } = useQuery(PayrollConceptsDocument, {
    variables: {
      policyPeriodId,
      categories,
      withActiveStatus,
    },
    skip: skip,
  })

  return {
    loading,
    concepts: data ? data.payroll.concepts : [],
    refetch,
  }
}

export const getConceptByName = (concepts: PayrollConceptFragment[], name: string) => {
  return concepts.find((concept) => concept.name === name) ?? null
}
